export const FORM = 'multipart/form-data'
export const JSON = 'application/json'
export const PDF = 'application/pdf'
export const TEXT_PLAIN = 'text/plain'
export const VTT = 'text/vtt'
